import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
//import Honeybadger from "@honeybadger-io/js";
import https from "https";
import axios from "axios";
import { getCookie, hasCookie, setCookie } from "cookies-next";
import getApiToken from "../getToken";
import * as ga from "../lib/ga";
let token = null;

let apolloClient = undefined;

const httpLink = new HttpLink({
  uri: `${process.env.CMS_API_URL}api/content/${process.env.CMS_PROJECT}/graphql`,
});

const authLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
  return forward(operation);
});

export const authApiClient = async () => {
  token = await getApiToken();
  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });
  return client;
};

const apiClient = async () => {
  token = await getApiToken();
  const client =
    apolloClient ??
    new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
    });

  if (!apolloClient) apolloClient = client;

  return client;
};

const webServiceClient = (loadingCallback) => {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const country = isAU ? "au" : "nz";
  const apiEndPoint = process.env.NEXT_PUBLIC_SEARCH_API_URL;
  const isProduction = process.env.NODE_ENV === "production";
  const isLocalApi =
    typeof window === "undefined" &&
    apiEndPoint &&
    (apiEndPoint.startsWith("https://localhost") ||
      apiEndPoint.startsWith("http://localhost"));
  const httpsAgent = isLocalApi
    ? new https.Agent({ rejectUnauthorized: false })
    : undefined;

  const privateInvoke = async (cUrl) => {
    try {
      if (loadingCallback) {
        loadingCallback(true);
      }

      const resp = await axios.get(cUrl, {
        ...(readCookie() || {}),
        ...(httpsAgent && { httpsAgent }),
      });

      if (loadingCallback) {
        loadingCallback(false);
      }

      saveCookie(resp);

      return resp;
    } catch (err) {
      console.log("Server Call Error", err);
      //Honeybadger.notify(err, { message: "API Call Exception url:" + cUrl });
      if (loadingCallback) {
        loadingCallback(false);
      }
    }
  };

  const privatePost = async (cUrl, data) => {
    try {
      if (loadingCallback) {
        loadingCallback(true);
      }

      const resp = await axios.post(cUrl, data, {
        ...(readCookie() || {}),
        ...(httpsAgent && { httpsAgent }),
      });

      if (loadingCallback) {
        loadingCallback(false);
      }
      saveCookie(resp);

      return resp;
    } catch (err) {
      console.log("Server Call Error", err);
      //Honeybadger.notify(err, { message: "API Call Exception url:" + cUrl });
      if (loadingCallback) {
        loadingCallback(false);
      }
    }
  };

  function readCookie() {
    let customHeaders = null;
    try {
      if (hasCookie("xuserid")) {
        customHeaders = {};
        customHeaders.xuserid = getCookie("xuserid");
      }
    } catch (error) {
      //incase if in server side
      // console.log("cookie get error");
    }
    if (customHeaders) {
      return { headers: customHeaders };
    }
    return customHeaders;
  }

  const saveCookie = (resp) => {
    try {
      if (resp.headers.xuserid) {
        if (!hasCookie("xuserid")) {
          const d = new Date();
          const exdays = 180;
          d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
          setCookie("xuserid", resp.headers.xuserid, { expires: d });
        }
      }
    } catch (error) {
      // console.log("cookie set error");
    }
  };

  return {
    regoSearch: async (state, rego, token) => {
      if (isProduction) {
        //only in production we log events
        ga.event({
          action: rego + "-" + state,
          params: {
            event_category: "REGO LOOKUP",
          },
        });
      }
      const data = {
        Licenceplate: rego,
        State: state,
        Token:token
      };
      const URL = `${apiEndPoint}/api/${country}/autoinfosearch/VehicleByLicencePlateD?${new URLSearchParams(
        data
      )}`;
      return await privateInvoke(URL);
    },

    vinSearch: async (vin,Token) => {
      if (isProduction) {
        //only in production we log events
        ga.event({
          action: vin,
          params: {
            event_category: "VIN LOOKUP",
          },
        });
      }
      const data = {
        vinString: vin,
        Token:Token
      };
      const URL = `${apiEndPoint}/api/${country}/autoinfosearch/SearchByVinNumber?${new URLSearchParams(
        data
      )}`;
      return await privateInvoke(URL);
    },

    searchResult: async (vehicleId) => {
      const data = {
        VehicleId: vehicleId,
      };
      const URL = `${apiEndPoint}/api/${country}/autoinfosearch/SearchResultsByKey?${new URLSearchParams(
        data
      )}`;

      return await privateInvoke(URL);
    },

    getPartsList: async (param) => {
      const data = param;

      // if(data.ReturnField
      //   =="Make"){
      //   const URL = `${apiEndPoint}/api/${country}/autoinfosearch/PartsGuide?${new URLSearchParams(
      //     data
      //   )}`;
      //   // const URLDEBUG = `${apiEndPoint}/api/${country}/autoinfosearch/debug`;
      //   // await privateInvoke(URLDEBUG);
      //   return await privateInvoke(URL);
      // }
      // else{
        const URL = `${apiEndPoint}/api/${country}/autoinfosearch/PartsGuide?${new URLSearchParams(
          data
        )}`;
        // const URLDEBUG = `${apiEndPoint}/api/${country}/autoinfosearch/debug`;
        // await privateInvoke(URLDEBUG);
        return await privateInvoke(URL);
      //}
     
    },

    getPublishedParts: async () => {
      //console.log("called getPublishedParts");
      const URL = `${apiEndPoint}/api/${country}/autoinfosearch/GetPublishedParts`;
      const partModelsWS = await axios.get(URL, { withCredentials: true });

      return partModelsWS;
    },

    getPublishedPartsList: async () => {
      const URL = `${apiEndPoint}/api/${country}/autoinfosearch/GetPublishedPartsList`;
      return await axios.get(URL, { withCredentials: true });
    },

    getPartNumberList: async (param) => {
      const data = { value: param };
      const URL = `${apiEndPoint}/api/${country}/autoinfosearch/PartNumberList?${new URLSearchParams(
        data
      )}`;
      return await privateInvoke(URL);
    },

    getXrefNumberList: async (param) => {
      const data = { value: param };
      const URL = `${apiEndPoint}/api/${country}/autoinfosearch/GetXrefNumberList?${new URLSearchParams(
        data
      )}`;

      return await privateInvoke(URL);
    },

    getSearchProduct: async (param1, param2, param3) => {
      const data = {
        ProductCode1: param1,
        ProductCode2: param2,
        ProductCode3: param3,
        IsWeb: true,
        CacheTokenId: "",
        uuid: "web",
      };
      const URL = `${apiEndPoint}/api/${country}/autoinfosearch/SearchXrefProduct`;
      return await privatePost(URL, data);
    },

    getProductByKey: async (param1) => {
      const data = {
        StockCode: param1,
        IsWeb: true,
        CacheTokenId: "",
        uuid: "web",
      };
      const URL = `${apiEndPoint}/api/${country}/autoinfosearch/SearchStockCode`;
      return await privatePost(URL, data);
    },
  };
};

export { webServiceClient };
export default apiClient;
